<template>
    <a-row>
        <a-col align="center" :lg="2"  @click="$emit('redirect_logout')">
            <LogoutOutlined :style="{ fontSize: '35px' }" />
        </a-col>
    </a-row>
</template>
<script>
import { LogoutOutlined } from '@ant-design/icons-vue';
export default ({
    emits: ['toggleProfileDrawer', 'redirect_logout' ],
    components: {
        LogoutOutlined
    }
})
</script>